import adminAxiosInstance from "./api/adminAxiosInstance";

/**
 * Cria um novo administrador no sistema.
 * @param {object} adminData - Dados do admin, incluindo nome, email, senha, etc.
 * @returns {Promise<object>} O objeto do admin criado.
 */
const createAdmin = async (adminData) => {
    const response = await adminAxiosInstance.post('admin', adminData);
    return response.data;
};

/**
 * Deleta um administrador pelo ID.
 * @param {number} adminId - O ID do admin a ser deletado.
 * @returns {Promise<void>}
 */
const deleteAdmin = async (adminId) => {
    await adminAxiosInstance.delete(`admin/${adminId}`);
};

/**
 * Atualiza as permissões de VISUALIZAÇÃO de um administrador.
 * @param {number} adminId - O ID do admin a ser atualizado.
 * @param {object} viewPermissions - O objeto com as permissões de visualização.
 * @returns {Promise<object>} O objeto do admin atualizado.
 */
const updateViewPermissions = async (adminId, viewPermissions) => {
    const response = await adminAxiosInstance.patch(`admin/${adminId}/permissions/view`, viewPermissions);
    return response.data;
};

/**
 * Atualiza as permissões de EDIÇÃO de um administrador.
 * @param {number} adminId - O ID do admin a ser atualizado.
 * @param {object} editPermissions - O objeto com as permissões de edição.
 * @returns {Promise<object>} O objeto do admin atualizado.
 */
const updateEditPermissions = async (adminId, editPermissions) => {
    const response = await adminAxiosInstance.patch(`admin/${adminId}/permissions/edit`, editPermissions);
    return response.data;
};

export const adminService = {
    createAdmin,
    deleteAdmin,
    updateViewPermissions,
    updateEditPermissions
};